import ApiService from '@/services/api.service.js';
import store from '@/store/index.js';

export default function useClientSubclientRepository(clientId) {
  const appsettings = store.state.appSettings;
  const isNotEmpty = (value) => value !== undefined && value !== null && value !== '';

  const load = (loadOptions) => {
    let params = '?';

    [
      'filter',
      'group',
      'groupSummary',
      'parentIds',
      'requireGroupCount',
      'requireTotalCount',
      'searchExpr',
      'searchOperation',
      'searchValue',
      'select',
      'sort',
      'skip',
      'take',
      'totalSummary',
      'userData',
    ].forEach((i) => {
      if (i in loadOptions && isNotEmpty(loadOptions[i])) {
        params += `${i}=${JSON.stringify(loadOptions[i])}&`;
      }
    });
    params = params.slice(0, -1);

    return ApiService
      .get(`${appsettings.ADMINISTRATION_API}/api/v1/masterdata/clients/${clientId}/subclients/overview${params}`);
  };

  const update = (key, values) => ApiService
    .put(`${appsettings.ADMINISTRATION_API}/api/v1/masterdata/clients/${clientId}/subclients/${key}`, { values: JSON.stringify(values) });

  const insert = (values) => ApiService
    .post(`${appsettings.ADMINISTRATION_API}/api/v1/masterdata/clients/${clientId}/subclients`, { values: JSON.stringify(values) });

  const remove = (key) => ApiService
    .delete(`${appsettings.ADMINISTRATION_API}/api/v1/masterdata/clients/${clientId}/subclients/${key}`);

  const importSubclients = async (allowMove, allowCreateSubclient, formData) => ApiService
    .post(`${appsettings.ADMINISTRATION_API}/api/v1/masterdata/clients/subclients/import/${allowMove}/${allowCreateSubclient}`, formData);

  return {
    load,
    update,
    insert,
    remove,
    importSubclients,
  };
}
